exports.components = {
  "component---cache-caches-gatsby-plugin-offline-app-shell-js": () => import("./../../caches/gatsby-plugin-offline/app-shell.js" /* webpackChunkName: "component---cache-caches-gatsby-plugin-offline-app-shell-js" */),
  "component---src-templates-column-tsx": () => import("./../../../src/templates/column.tsx" /* webpackChunkName: "component---src-templates-column-tsx" */)
}

